module.exports = __webpack_public_path__ + "img/mcb-r1.b46f1ce8.gif";